import { Helper } from '../Helper';
export class ArrSomeFuncHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getCallable({}));
        sb.emitOp(node, 'SWAP');
        sb.emitSysCall(node, 'Neo.Enumerator.Create');
        sb.emitPushInt(node, 0);
        sb.emitPushBoolean(node, false);
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'NOT');
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
                sb.emitOp(node, 'BOOLAND');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'NIP');
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICK');
                sb.emitHelper(node, options, sb.helpers.wrapNumber);
                sb.emitOp(node, 'SWAP');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'PICK');
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.call);
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.unwrapBoolean);
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'INC');
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'ROT');
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'NIP');
                sb.emitOp(node, 'NIP');
            },
        }));
    }
}

//# sourceMappingURL=ArrSomeFuncHelper.js.map
